import { Link, type LinkProps } from 'react-router-dom'
import {
  BUTTON_BASE,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  type ButtonSize,
  type ButtonVariant,
} from './Button'
import { cx } from '@/lib/cx'

interface Props extends LinkProps {
  variant?: ButtonVariant
  size?: ButtonSize
  block?: boolean
}

/** Not `<Link><Button/></Link>`: nesting a button inside an anchor is invalid
 *  HTML. Navigation is a link; an action is a button. */
export function LinkButton({
  variant = 'primary',
  size = 'default',
  block = false,
  className,
  children,
  ...rest
}: Props) {
  return (
    <Link
      className={cx(
        BUTTON_BASE,
        BUTTON_SIZES[size],
        BUTTON_VARIANTS[variant],
        block && 'w-full',
        className,
      )}
      {...rest}
    >
      {children}
    </Link>
  )
}
